import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useDeleteEvent = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("DELETE", `/admin/event/${idx}`)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(-1)
                break
            case 400:
                if (fetchResult?.data?.error_code === "event_idx") setAlert("대회 idx를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default useDeleteEvent